import { defineComponent as _defineComponent } from 'vue'
import TAccordion from '~/components/atoms/t-accordion.vue';
import FaqAnswer from '~/components/collection/FaqAnswer.vue';

interface Props {
  faqContent: {
    question: string;
    answer: string;
  }[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FaqSection',
  props: {
    faqContent: null
  },
  setup(__props: any) {



return { __sfc: true,TAccordion, FaqAnswer }
}

})